import AllApplicationsTemplate from "./Template";

const AllOtApplications = () => <AllApplicationsTemplate type="OT" />;

export default AllOtApplications;
